import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EfficiencyAnalysisMarkerService {
  private isEfficiencyAnalysisDisabledStore = new BehaviorSubject(false);
  public isEfficiencyAnalysisDisabled$ = this.isEfficiencyAnalysisDisabledStore.asObservable();
  public setEfficiencyAnalysisDisabledValue(value: boolean) {
    this.isEfficiencyAnalysisDisabledStore.next(value);
  }
  public getIsEfficiencyAnalysisDisabledValue() {
    return this.isEfficiencyAnalysisDisabledStore.getValue();
  }
}
